import { User } from "app/types"

export const users: User[] = [
  // near
  {
    badge_counts: {
      bronze: 38,
      silver: 13,
      gold: 4,
    },
    account_id: 13078034,
    is_employee: false,
    last_modified_date: 1603186800,
    last_access_date: 1603228745,
    reputation_change_year: 3925,
    reputation_change_quarter: 1033,
    reputation_change_month: 1033,
    reputation_change_week: 203,
    reputation_change_day: 43,
    reputation: 4348,
    creation_date: 1520315088,
    user_type: "registered",
    user_id: 9449426,
    location: "Vietnam",
    website_url: "https://near.netlify.app",
    link: "https://stackoverflow.com/users/9449426/nearhuscarl",
    profile_image:
      "https://www.gravatar.com/avatar/68f65f424fd34b2e1a7e875f9311f88c?s=128&d=identicon&r=PG&f=1",
    display_name: "NearHuscarl",
  },
  {
    badge_counts: {
      bronze: 65,
      silver: 44,
      gold: 3,
    },
    account_id: 485485,
    is_employee: false,
    last_modified_date: 1602758400,
    last_access_date: 1602807479,
    reputation_change_year: 1637,
    reputation_change_quarter: 135,
    reputation_change_month: 135,
    reputation_change_week: 40,
    reputation_change_day: 0,
    reputation: 16390,
    creation_date: 1313730622,
    user_type: "registered",
    user_id: 901827,
    accept_rate: 62,
    website_url: "",
    link: "https://stackoverflow.com/users/901827/linearzoetrope",
    profile_image:
      "https://www.gravatar.com/avatar/86a6acccf7e8dbe398ebda4f8524ed50?s=128&d=identicon&r=PG",
    display_name: "LinearZoetrope",
  },
  {
    badge_counts: {
      bronze: 41,
      silver: 35,
      gold: 14,
    },
    account_id: 12015,
    is_employee: false,
    last_modified_date: 1573688472,
    last_access_date: 1303770229,
    reputation_change_year: 370,
    reputation_change_quarter: 240,
    reputation_change_month: 240,
    reputation_change_week: 0,
    reputation_change_day: 0,
    reputation: 11017,
    creation_date: 1222695782,
    user_type: "registered",
    user_id: 23447,
    accept_rate: 79,
    website_url: "",
    link: "https://stackoverflow.com/users/23447/nearly-lunchtime",
    profile_image:
      "https://www.gravatar.com/avatar/e21f12e918bb5fb50acd10d24e0c0772?s=128&d=identicon&r=PG",
    display_name: "nearly_lunchtime",
  },
  {
    badge_counts: {
      bronze: 55,
      silver: 44,
      gold: 4,
    },
    account_id: 12867,
    is_employee: false,
    last_modified_date: 1584860102,
    last_access_date: 1602804961,
    reputation_change_year: 188,
    reputation_change_quarter: 118,
    reputation_change_month: 118,
    reputation_change_week: 0,
    reputation_change_day: 0,
    reputation: 9105,
    creation_date: 1223311299,
    user_type: "registered",
    user_id: 25549,
    accept_rate: 100,
    location: "Orange, CA, United States",
    website_url: "https://www.mcnearney.net",
    link: "https://stackoverflow.com/users/25549/lance-mcnearney",
    profile_image:
      "https://www.gravatar.com/avatar/1440826ae9908cf7c415dbfd3a66b240?s=128&d=identicon&r=PG",
    display_name: "Lance McNearney",
  },
  {
    badge_counts: {
      bronze: 61,
      silver: 32,
      gold: 4,
    },
    account_id: 2108855,
    is_employee: false,
    last_modified_date: 1599067800,
    last_access_date: 1602855720,
    reputation_change_year: 1215,
    reputation_change_quarter: 277,
    reputation_change_month: 28,
    reputation_change_week: 10,
    reputation_change_day: 0,
    reputation: 8146,
    creation_date: 1354594893,
    user_type: "registered",
    user_id: 1874522,
    accept_rate: 57,
    location: "Southfield, MI, United States",
    website_url: "https://blog.pinarydevelopment.com",
    link: "https://stackoverflow.com/users/1874522/peinearydevelopment",
    profile_image: "https://i.stack.imgur.com/1BXUD.png?s=128&g=1",
    display_name: "peinearydevelopment",
  },
  {
    badge_counts: {
      bronze: 35,
      silver: 28,
      gold: 2,
    },
    account_id: 12271,
    is_employee: false,
    last_modified_date: 1581730807,
    last_access_date: 1602857828,
    reputation_change_year: 22,
    reputation_change_quarter: 12,
    reputation_change_month: 12,
    reputation_change_week: 0,
    reputation_change_day: 0,
    reputation: 6863,
    creation_date: 1222855930,
    user_type: "registered",
    user_id: 24071,
    accept_rate: 100,
    location: "United Kingdom",
    website_url: "https://blog.chimusoftware.com",
    link: "https://stackoverflow.com/users/24071/paul-nearney",
    profile_image:
      "https://www.gravatar.com/avatar/c3bee9cab96a2940d581d2dca0e30449?s=128&d=identicon&r=PG",
    display_name: "Paul Nearney",
  },
  {
    badge_counts: {
      bronze: 73,
      silver: 40,
      gold: 10,
    },
    account_id: 2382594,
    is_employee: false,
    last_modified_date: 1588180500,
    last_access_date: 1599904912,
    reputation_change_year: 360,
    reputation_change_quarter: 240,
    reputation_change_month: 240,
    reputation_change_week: 10,
    reputation_change_day: 0,
    reputation: 6622,
    creation_date: 1361210704,
    user_type: "registered",
    user_id: 2084311,
    accept_rate: 70,
    location: "Ann Arbor, MI, USA",
    website_url: "http://www.memrey.com",
    link: "https://stackoverflow.com/users/2084311/nearpoint",
    profile_image:
      "https://www.gravatar.com/avatar/d0bfa2d6a909f40bf2d0c6d900f2da4d?s=128&d=identicon&r=PG",
    display_name: "Nearpoint",
  },
  {
    badge_counts: {
      bronze: 28,
      silver: 25,
      gold: 0,
    },
    account_id: 4501,
    is_employee: false,
    last_modified_date: 1573688752,
    last_access_date: 1360838338,
    reputation_change_year: 140,
    reputation_change_quarter: 100,
    reputation_change_month: 100,
    reputation_change_week: 0,
    reputation_change_day: 0,
    reputation: 5667,
    creation_date: 1221482328,
    user_type: "registered",
    user_id: 6799,
    location: "Lithuania",
    website_url: "http://aras-p.info",
    link: "https://stackoverflow.com/users/6799/nearaz",
    profile_image:
      "https://www.gravatar.com/avatar/f7c2a28b987d5be050e371270bdc785f?s=128&d=identicon&r=PG",
    display_name: "NeARAZ",
  },
  // jon
  {
    badge_counts: {
      bronze: 8827,
      silver: 8569,
      gold: 775,
    },
    account_id: 11683,
    is_employee: false,
    last_modified_date: 1602303309,
    last_access_date: 1602858567,
    reputation_change_year: 60023,
    reputation_change_quarter: 3355,
    reputation_change_month: 3355,
    reputation_change_week: 1245,
    reputation_change_day: 200,
    reputation: 1214548,
    creation_date: 1222430705,
    user_type: "registered",
    user_id: 22656,
    accept_rate: 86,
    location: "Reading, United Kingdom",
    website_url: "http://csharpindepth.com",
    link: "https://stackoverflow.com/users/22656/jon-skeet",
    profile_image:
      "https://www.gravatar.com/avatar/6d8ebb117e8d83d74ea95fbdd0f87e13?s=128&d=identicon&r=PG",
    display_name: "Jon Skeet",
  },
  {
    badge_counts: {
      bronze: 1152,
      silver: 779,
      gold: 111,
    },
    account_id: 8423,
    is_employee: false,
    last_modified_date: 1602754801,
    last_access_date: 1602857030,
    reputation_change_year: 34791,
    reputation_change_quarter: 2065,
    reputation_change_month: 2065,
    reputation_change_week: 775,
    reputation_change_day: 80,
    reputation: 643480,
    creation_date: 1221633947,
    user_type: "registered",
    user_id: 15168,
    accept_rate: 100,
    location: "Colorado, USA",
    website_url: "https://stackoverflow.com/users/15168",
    link: "https://stackoverflow.com/users/15168/jonathan-leffler",
    profile_image: "https://i.stack.imgur.com/WtEI9.png?s=128&g=1",
    display_name: "Jonathan Leffler",
  },
  {
    badge_counts: {
      bronze: 758,
      silver: 675,
      gold: 68,
    },
    account_id: 20816,
    is_employee: false,
    last_modified_date: 1601399400,
    last_access_date: 1602849071,
    reputation_change_year: 18132,
    reputation_change_quarter: 6191,
    reputation_change_month: 2683,
    reputation_change_week: 378,
    reputation_change_day: 30,
    reputation: 383738,
    creation_date: 1230613552,
    user_type: "registered",
    user_id: 50079,
    accept_rate: 67,
    location: "Berlin",
    website_url: "",
    link: "https://stackoverflow.com/users/50079/jon",
    profile_image: "https://i.stack.imgur.com/ud1xq.png?s=128&g=1",
    display_name: "Jon",
  },
  {
    badge_counts: {
      bronze: 299,
      silver: 227,
      gold: 30,
    },
    account_id: 9467,
    is_employee: false,
    last_modified_date: 1593709500,
    last_access_date: 1602541669,
    reputation_change_year: 5034,
    reputation_change_quarter: 1786,
    reputation_change_month: 1786,
    reputation_change_week: 130,
    reputation_change_day: 10,
    reputation: 175368,
    creation_date: 1221733791,
    user_type: "registered",
    user_id: 17516,
    accept_rate: 77,
    location: "Birmingham, United Kingdom",
    website_url: "http://geekswithblogs.net/codingbloke",
    link: "https://stackoverflow.com/users/17516/anthonywjones",
    profile_image:
      "https://www.gravatar.com/avatar/91973b1bef91ee4f314cd95a37a45f2b?s=128&d=identicon&r=PG",
    display_name: "AnthonyWJones",
  },
  {
    badge_counts: {
      bronze: 469,
      silver: 292,
      gold: 20,
    },
    account_id: 956801,
    is_employee: false,
    last_modified_date: 1600248900,
    last_access_date: 1602857857,
    reputation_change_year: 7175,
    reputation_change_quarter: 2505,
    reputation_change_month: 1032,
    reputation_change_week: 110,
    reputation_change_day: 40,
    reputation: 148585,
    creation_date: 1317895255,
    user_type: "registered",
    user_id: 981959,
    location: "London, United Kingdom",
    website_url: "http://advogato.org/person/redi/",
    link: "https://stackoverflow.com/users/981959/jonathan-wakely",
    profile_image:
      "https://www.gravatar.com/avatar/04798ba8ef6591a9c23c5868dc0bf664?s=128&d=identicon&r=PG",
    display_name: "Jonathan Wakely",
  },
  {
    badge_counts: {
      bronze: 204,
      silver: 191,
      gold: 26,
    },
    account_id: 453984,
    is_employee: false,
    last_modified_date: 1601658301,
    last_access_date: 1602551396,
    reputation_change_year: 4468,
    reputation_change_quarter: 200,
    reputation_change_month: 200,
    reputation_change_week: 80,
    reputation_change_day: 0,
    reputation: 133048,
    creation_date: 1311051667,
    user_type: "registered",
    user_id: 851273,
    location: "U.S.",
    website_url: "http://www.tesuji.org/",
    link: "https://stackoverflow.com/users/851273/jon-lin",
    profile_image: "https://i.stack.imgur.com/kGxQa.gif?s=128&g=1",
    display_name: "Jon Lin",
  },
  {
    badge_counts: {
      bronze: 271,
      silver: 272,
      gold: 27,
    },
    account_id: 229440,
    is_employee: false,
    last_modified_date: 1601398200,
    last_access_date: 1602801534,
    reputation_change_year: 7109,
    reputation_change_quarter: 2529,
    reputation_change_month: 1008,
    reputation_change_week: 130,
    reputation_change_day: 20,
    reputation: 123527,
    creation_date: 1288472915,
    user_type: "registered",
    user_id: 492405,
    accept_rate: 88,
    location: "Alexandria, VA",
    website_url: "https://vcsjones.dev",
    link: "https://stackoverflow.com/users/492405/vcsjones",
    profile_image: "https://i.stack.imgur.com/SSPGk.png?s=128&g=1",
    display_name: "vcsjones",
  },
  // moderator
  {
    badge_counts: {
      bronze: 88,
      silver: 71,
      gold: 16,
    },
    account_id: 2751107,
    is_employee: false,
    last_modified_date: 1601930100,
    last_access_date: 1602960288,
    reputation_change_year: 1311,
    reputation_change_quarter: 100,
    reputation_change_month: 100,
    reputation_change_week: 10,
    reputation_change_day: 0,
    reputation: 27648,
    creation_date: 1368197704,
    user_type: "moderator",
    user_id: 2370483,
    accept_rate: 89,
    link: "https://stackoverflow.com/users/2370483/machavity",
    profile_image: "https://i.stack.imgur.com/Y0oJ0.jpg?s=128&g=1",
    display_name: "Machavity",
  },
]

export function createUsersMatching(name: string, count: number = 1) {
  const userMatching = {
    display_name: expect.stringMatching(new RegExp(name, "i")),
  }

  if (count === 1) {
    return userMatching
  }

  const results = [] as any[]
  for (let i = 0; i < count; i++) {
    results.push(userMatching)
  }
  return results
}
